import { useMutation } from "@apollo/client";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useSnackbar } from "notistack";
import React from "react";
import { CREATE_COMPANY, UPDATE_COMPANY } from "../../graphql/mutations";
import { CreateCompanyMutation } from "../../graphql/mutations/createCompany";
import { UpdateCompanyMutation } from "../../graphql/mutations/updateCompany";
import { LIST_ALL_COMPANIES_FILTERED } from "../../graphql/queries";
import {
  CreateCompanyMutationVariables,
  UpdateCompanyMutationVariables,
} from "../../graphql/types";
import CompanyForm, { CompanyFormValues } from "./CompanyForm";

interface Props {
  id?: string;
  open: boolean;
  initialValues?: CompanyFormValues;

  handleClose: () => any;
}

const CompanyDialog: React.FC<Props> = ({
  open,
  handleClose,
  id,
  initialValues,
}) => {
  const isEditting = !!id;
  const { enqueueSnackbar } = useSnackbar();

  const [add, { loading: addLoading }] = useMutation<
    CreateCompanyMutation,
    CreateCompanyMutationVariables
  >(CREATE_COMPANY, {
    refetchQueries: [
      { query: LIST_ALL_COMPANIES_FILTERED, variables: { name: "" } },
    ],
    onError() {
      enqueueSnackbar("Konnte Auftraggeber nicht anlegen", {
        variant: "error",
      });
    },
    onCompleted() {
      enqueueSnackbar("Auftraggeber hinzugefügt", { variant: "success" });
      handleClose();
    },
  });

  const [update, { loading: updateLoading }] = useMutation<
    UpdateCompanyMutation,
    UpdateCompanyMutationVariables
  >(UPDATE_COMPANY, {
    onError(error) {
      enqueueSnackbar("Konnte Auftraggeber nicht speicher", {
        variant: "error",
      });
    },
    onCompleted() {
      enqueueSnackbar("Auftraggeber gespeichert", { variant: "success" });
      handleClose();
    },
  });

  const handleSubmit = ({
    name,
    defaultSelfTests,
    hasSelfTests,
  }: CompanyFormValues) => {
    if (isEditting && id) {
      return update({
        variables: {
          input: {
            id,
            name,
            settings: {
              hasSelfTests: hasSelfTests,
              defaultSelfTests: defaultSelfTests,
            },
          },
        },
      });
    } else {
      return add({
        variables: {
          input: {
            name,
            settings: {
              hasSelfTests: hasSelfTests,
              defaultSelfTests: defaultSelfTests,
            },
          },
        },
      });
    }
  };

  return (
    <Dialog
      open={open}
      disableBackdropClick={addLoading || updateLoading}
      disableEscapeKeyDown={addLoading || updateLoading}
      onClose={handleClose}
      aria-labelledby="company-dialog-title"
    >
      <DialogTitle id="company-title">
        {isEditting ? "Auftraggeber bearbeiten" : "Auftraggeber hinzufügen"}
      </DialogTitle>
      <DialogContent>
        <CompanyForm
          onSubmit={handleSubmit}
          loading={addLoading || updateLoading}
          initi={initialValues}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDialog;
